import React, {useEffect} from 'react';
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from 'react-redux';
import MindsetsJsSDK, {LoadMeAction, rolesConstants} from "mindsets-js-sdk";

import analytic from "utils/Analytic";
import {AddLastEventAction, AddLocationAction} from "./actions/history_actions";

export default () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const me = useSelector(state => state.me);

    function catchClicks(event) {
        dispatch(AddLastEventAction({
            TAG: event.target.tagName,
            ID: event.target.id || 'N/A',
            CLASS: event.target.className ? event.target.className.toString() : 'N/A',
            LOC: location.pathname,
            HREF: event.target.href || 'N/A',
            TIME: event.timeStamp,
            TYPE: event.type,
            POINTER: event.pointerType,
            TEXT: event.target.innerText ? event.target.innerText.substring(0, 20) : ''
        }));
    }

    useEffect(() => {
        if (MindsetsJsSDK().Auth.isAuthenticated()) {
            dispatch(LoadMeAction());
        }
    }, []);

    useEffect(() => {
        window.addEventListener('click', catchClicks);

        return () => window.removeEventListener('click', catchClicks);
    }, []);

    useEffect(() => {
        let user_channel;
        if (me) {
            analytic.init(me.id);
            user_channel = pusher.subscribe('user_' + me.id);
            user_channel.bind('signed_out', function () {
                MindsetsJsSDK().Auth.logout();
                window.location.href = "/";
            });
            user_channel.bind('user.updated', () => dispatch(LoadMeAction()));
        }

        return () => {
            if (user_channel) {
                user_channel.unbind_all();
                user_channel.unsubscribe();
            }
        }
    }, [me]);

    useEffect(() => {
        if (me && process.env.FEATURE_SWITCH_NEW_PROFILE === true) {
            const has_visited = me.general_data && me.general_data.dashboard_visited === 1;
            const has_grades = Array.isArray(me.grades) && me.grades.length > 0 || rolesConstants.ROLE_STUDENT === me.persona;
            const has_school = !!me.school_id || rolesConstants.ROLE_STUDENT === me.persona;
            const profile_completed = me.fname && me.lname && has_grades;
            switch (true) {
                case !!me.password_reset:
                    if (location.pathname !== '/profile/password') {
                        navigate('/profile/password');
                    }
                    break;
                case !me.password_reset && location.pathname === '/profile/password':
                    navigate('/');
                    break;
                case rolesConstants.ROLE_STUDENT === me.persona && ['/profile/school', '/profile/school/add'].includes(location.pathname):
                    navigate('/');
                    break;
                case !has_school:
                    if (!['/profile/school', '/profile/school/add'].includes(location.pathname)) {
                        navigate('/profile/school');
                    }
                    break;
                case (!has_visited || !profile_completed):
                    if (location.pathname !== '/profile/update') {
                        navigate('/profile/update');
                    }
                    break;
            }
        }
    }, [me, location]);

    useEffect(() => {
        dispatch(AddLocationAction(location));
    }, [location]);

    return (
        <Outlet/>
    );
};
